import { FormControl, FormGroup } from '@angular/forms';

export function phone_validator(c: FormControl) {
  var phone_number = c.value;
  if(phone_number === '' || phone_number === undefined) {
    return null;
  }

  var re = new RegExp('^\\(\\d{3}\\)\\s\\d{3}\\-\\d{4}$', 'g');

  if(!phone_number.match(re)) {
    return {
      valid: false
    }
  }
  return null;
}

export function url_validator(c: FormControl) {
  var url = c.value;
  if (url === "" || url === undefined) {
    return null;
  }

  var re = new RegExp("(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?", "g");

  if (!url.match(re)) {
    return {
      valid: false
    };
  }
  return null;
}


export function name_validator(c: FormControl) {
  var user_name = c.value;

  if(user_name === null || user_name === undefined) {
    return {
      valid: false
    }
  }

  if(!user_name.match(/[a-zA-Z]+/g)) {
    return {
      valid: false
    }
  }

  return null;
}

var re = new RegExp("[\\w\\d!#$%&\'*+\/=?^_`{|}~-]+(?:\.[\\w\\d!#$%&\'*+\/=?^_`{|}~-]+)*@(?:[\\w\\d](?:[\\w\\d-]*[\\w\\d])?\.)+[\\w\\d](?:[\\w\\d-]*[\\w\\d])", 'g');
var re2 = new RegExp("@[\\w?]+[\.]?$")

export function email_validator(c: FormControl) {
  var email = c.value;

  if(email === null || email === undefined) {
    return {
      valid: false
    }
  }

  if(email.includes(' ')) {
    return {
      valid: false
    }
  }

  if(!email.match(re) || email.match(re2)) {
    return {
      valid: false
    }
  }
  return null;
}

export function email_list_validator(c: FormControl) {
  var emails = c.value;

  if(emails === null || emails === undefined || emails === '') {
    return null
  }

  var emails = emails.split(";");
  var dup_list = []
  for(var i in emails) {
    var email = emails[i].replace(/ /g, '');

    // Check for duplicate emails in the list
    if(dup_list.indexOf(email) !== -1){
      return {
        valid: false
      }
    }
    dup_list.push(email);

    if(!email.match(re) || email.match(re2)) {
      return {
        valid: false
      }
    }
  }

  return null;
}

export function select_validator(c: FormControl) {
  var value = c.value;

  if(value === '') {
    return {
      valid: false
    }
  }
  return null;
}

export function donation_validator(c: FormControl) {
  if(c.value === null){
    return null;
  }

  var amount = c.value.toString();

  amount = amount.replace(/[$ ]+/g, "");
  amount = amount.replace(/[,]+/g, "");
  amount = parseFloat(amount);

  // Returns false if the input is invalid
  if(amount <= 0.0) {
    return {
      valid: false
    }
  }

  // stripe does not accept payments over $999,999.99
  if(amount > 999999.99) {
    return {valid: false}
  }

  // null is returned when the input is valid
  return null;
}

export function password_validator(c: FormControl) {
  var password = c.value

  if(password) {
    if(password.match(/\d+/g) !== null) {
      if(password.match(/[a-z]+/g) !== null) {
        if(password.match(/[A-Z]+/g) !== null) {
          return null;
        }
      }
    }
  }

  return {valid: false}
}

// Form validator for the password fields.
// Checks to see if the password and password repeat fields match.
export function password_match_validator(password: string, password_repeat: string) {
  return (group: FormGroup): {[key: string]: any} => {
    let pass = group.controls['password'];
    let pass_repeat = group.controls['password_repeat'];

    if(pass === undefined || pass_repeat === undefined) {
      return{
        valid: false
      }
    }

    if (pass.value !== pass_repeat.value) {
      return {
        mismatchedPasswords: true
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/validators/validators.ts